import { authActions, callActions, servicesActions } from '@lifesize/nucleus';
import { remotingActions } from '@lifesize/clients.remoting';
import ActionsPresentation from 'actions/presentation';
import ActionTypes from 'constants/ActionTypes';
import homeSelector from 'selectors/home';

/**
 * Login the presenter into nucleus
 * @param store the store
 * @param jwt the javascript web token provided by the linking code
 */
export async function login(store: any, jwt: string) {
  try {
    /* Attempt to use the JWT provided.
     * if a jwt is provided, nucleus should log in with the jwt and ignore the cookie (a cookie may be present if a
     * presenter also uses the web app) */
    await store.dispatch(servicesActions.connect(jwt, true));
    /* a login failure should be caught in the 'catch' below */
    // subscribe to linking for the duration of the login (to listen for 'unpairing' event)
    await store.dispatch(remotingActions.pairing.subscribeToLinking());
    await store.dispatch(remotingActions.remoting.subscribeToEvents()); // subscribes to ls.deviceMessaging
    await store.dispatch(callActions.getRelayServersGalaxy()); // request turn servers
  }
  catch (e) {
    // the error returned here is not useful to the end user, so replace it with something readable
    store.dispatch({ type: ActionTypes.LoginError });
  }
}

/**
 * Logout the presenter from nucleus
 * @param store the store
 */
export async function logout(store: any) {
  try {
    if (homeSelector(store.getState()).isPresenting) {
      await store.dispatch(ActionsPresentation.sendWirelessEnd({ onlyEndSelf: true }));
    }
    await store.dispatch(remotingActions.remoting.unsubscribeFromEvents()); // unsubscribes from ls.deviceMessaging
    await store.dispatch(remotingActions.pairing.unsubscribeFromLinking());
    await store.dispatch(authActions.logout());
  }
  catch (e) {
    // simply reload the page if all else fails
    window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/utils/presenting.ts